// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-icon-button-container {
  position: relative;
}

.menu-icon-button-sub {
  position: absolute;
  border: 1px solid var(--light-grey);
  top: 5px;
  right: 5px;
  width: calc(var(--input-element-height) / 2);
  height: calc(var(--input-element-height) / 2);
  min-width: unset;
  font-size: var(--font-size-m);
  background-color: var(--dialog-background-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/menu-icon-button/MenuIconButton.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,QAAQ;EACR,UAAU;EACV,4CAA4C;EAC5C,6CAA6C;EAC7C,gBAAgB;EAChB,6BAA6B;EAC7B,gDAAgD;AAClD","sourcesContent":[".menu-icon-button-container {\n  position: relative;\n}\n\n.menu-icon-button-sub {\n  position: absolute;\n  border: 1px solid var(--light-grey);\n  top: 5px;\n  right: 5px;\n  width: calc(var(--input-element-height) / 2);\n  height: calc(var(--input-element-height) / 2);\n  min-width: unset;\n  font-size: var(--font-size-m);\n  background-color: var(--dialog-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
